mutation UpdateAttendeeStatus(
  $attendeeId: ID
  $status: EventAttendeeStatusEnum!
  $reason: String
  $notify: Boolean
  $wholeParty: Boolean
) {
  updateAttendeeStatus(
    input: {
      attendeeId: $attendeeId
      status: $status
      reason: $reason
      notify: $notify
      wholeParty: $wholeParty
    }
  ) {
    attendee {
      id
      status
    }
  }
}
